import { toast } from 'react-toastify';
import { customAlert } from './alertActions';
import {
	ADD_QTY,
	ADD_TO_CART,
	EMPTY_CART,
	REMOVE_FROM_CART,
	SUB_QTY,
} from './types';
export const addToCart = obj => async dispatch => {
	dispatch({
		type: ADD_TO_CART,
		payload: obj,
	});
	// toast.success('Added to Cart');
	dispatch(customAlert(true, 'Added to Cart'));
	setTimeout(() => {
		dispatch(customAlert(false, ''));
	}, 3000);
};
export const removeFromCart = id => async dispatch => {
	dispatch({
		type: REMOVE_FROM_CART,
		payload: id,
	});
};
export const subQuantity = id => async dispatch => {
	dispatch({
		type: SUB_QTY,
		payload: id,
	});
};
export const addQuantity = id => async dispatch => {
	dispatch({
		type: ADD_QTY,
		payload: id,
	});
};
export const clearCart = () => async dispatch => {
	dispatch({
		type: EMPTY_CART,
	});
};
